import { createTeamResourceContext } from './createTeamResourceContext'
import useProjectsResources from '../shared/resources/api/v1/admin/docker/useProjectsResources'

const { Provider: ProjectsProvider, useHook: useProjects, useSafeHook: useProjectsSafe } = createTeamResourceContext({
  name: 'Projects',
  useResources: useProjectsResources,
  responseKey: 'projects',
  lookups: [
    { key: 'projectsById', field: 'id' },
    { key: 'projectsBySlug', field: 'slug' },
  ],
})

export { ProjectsProvider, useProjects, useProjectsSafe }
